// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"ee0f4eb0","808":"5664ebed","875":"b37fad64"}[chunkId] + ".chunk.js";
};